(function() {
    angular
        .module('emarket.main.post')
        .factory('Post', ['$document', '$mdToast', '$mdMedia', '$http', '$rootScope', '$mdPanel', '$mdDialog', '$location', '$timeout', 'restmod', 'PATH', function($document,
            $mdToast,
            $mdMedia,
            $http,
            $rootScope,
            $mdPanel,
            $mdDialog,
            $location,
            $timeout,
            restmod,
            PATH) {
            var url = '/post';
            var postPanel;
            var imageList = [];
            var rest = restmod.mixin(function() {
                this.define('Model.unpackMany', function(_rawData) {
                    return _rawData;
                });
                this.define('Model.unpack', function(_rawData, _record) {
                    if (_record.data) {
                        _rawData.$metadata = {
                            filter: _record.filter,
                            limit: _record.limit,
                            skip: _record.skip,
                            total: _record.total,
                            suggestion: _record.suggestion
                        };
                        return _record.data;
                    } else {
                        return _record;
                    }
                });
            });
            var model = restmod.model('/post').mix(rest);
            model.getLatest = function() {
                var path = PATH.api + url + '/c/latest';
                var promise = $http.get(path).then(function(response) {
                    return response.data;
                });
                return promise;
            };
            model.CONDITIONS = [ 'new', 'used', 'refurbish', 'damaged', 'na' ];
            model.events = {
                SHOW_FILTER_DIALOG: 'search_show_filter_dialog',
                SHOW_FILTER_BUTTON: 'search_show_filter_button'
            };
            model.hidePostPanel = function() {
                if (postPanel) {
                    postPanel.close();
                }
            };
            model.getPostPanel = function() {
                return postPanel;
            };
            model.images = {
                add: function(image) {
                    imageList.push(image);
                },
                get: function() {
                    return imageList;
                },
                clear: function() {
                    imageList = [];
                }
            };

            model.report = function(post) {
                var isMobile = !$mdMedia('gt-sm');
                var fullscreen = isMobile ? true : false;
                var position = isMobile
                    ? $mdPanel
                        .newPanelPosition()
                        .absolute()
                        .top('0')
                        .left('0')
                    : $mdPanel
                        .newPanelPosition()
                        .absolute()
                        .center();
                $location.search('reportar', 1);
                $timeout(function() {
                    $mdPanel.open({
                        position: position,
                        locals: {
                            post: post
                        },
                        templateUrl: 'main/post/report/report.tpl.html',
                        controller: 'ReportPostController as model',
                        attachTo: angular.element($document[0].body),
                        zIndex: 102,
                        hasBackdrop: true,
                        fullscreen: fullscreen,
                        trapFocus: true,
                        panelClass: 'report-post__panel',
                        escapeToClose: true,
                        onOpenComplete: function() {
                            $rootScope.$emit('scroll:disable', true);
                        },
                        onCloseSuccess: function(panel, response) {
                            var toast = $mdToast
                                .simple()
                                .textContent('Gracias por reportarlo, estaremos revisando')
                                .hideDelay(3000);
                            if (!response) {
                                $mdToast.show(toast);
                            }
                            $location.search('reportar', null);
                            $rootScope.$emit('scroll:disable');
                            panel.destroy();
                        }
                    });
                });
            };

            model.showPostPanel = function(element, selected) {
                var animation = $mdPanel
                    .newPanelAnimation()
                    .duration(200)
                    .openFrom(element)
                    .closeTo(element)
                    .withAnimation($mdPanel.animation.SCALE);

                $mdPanel
                    .open({
                        position: $mdPanel
                            .newPanelPosition()
                            .absolute()
                            .top('0')
                            .left('0'),
                        templateUrl: 'main/post/detail/detail.panel.tpl.html',
                        animation: animation,
                        panelClass: 'post-detail__panel-container',
                        zIndex: 101,
                        fullscreen: true,
                        controllerAs: 'model',
                        trapFocus: true,
                        controller: 'PostPanelDetailController',
                        resolve: {
                            post: function() {
                                return model.$find(selected.id).$asPromise();
                            }
                        },
                        locals: {
                            selected: selected
                        },
                        onOpenComplete: function() {
                            $rootScope.$emit('scroll:disable', true);
                        },
                        onCloseSuccess: function() {
                            $rootScope.$emit('scroll:disable');
                        }
                    })
                    .then(function(refPanel) {
                        postPanel = refPanel;
                    });
            };

            model.refresh = function(id) {
                var path = PATH.api + url + '/' + id + '/refresh';
                var promise = $http.post(path).then(function(response) {
                    return response.data;
                });
                return promise;
            };
            model.refreshSeveral = function(ids) {
                var path = PATH.api + url + '/c/refresh';
                var promise = $http.post(path, { ids: ids }).then(function(response) {
                    return response.data;
                });
                return promise;
            };
            model.deleteSeveral = function(ids) {
                var path = PATH.api + url + '/bulk/delete';
                var promise = $http
                    .delete(path, { data: { ids: ids } })
                    .then(function(response) {
                        return response.data;
                    });
                return promise;
            };
            return model;
        }]);
}());
